// extracted by mini-css-extract-plugin
export default {"page":"mQ","wrapper":"nQ","text":"oQ","icons":"pQ","icon":"qQ","icon_text":"rQ","carousel_wrapper":"sQ","slide":"tQ","image":"uQ","arrows":"vQ","prev":"wQ","modal_root":"xQ","x_mark":"yQ","modal":"zQ","images":"AQ","main_image":"BQ","name":"CQ"};
    if(module.hot) {
      // 1715632478449
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  